import React, { useState } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation for path checking

const Navbar = ({ landingPageData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Get the current location

  // Function to toggle mobile menu open/close state
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Function to check if the current path matches the link's href
  const isActive = (path) => location.hash === path;

  return (
    <div className="bg-transparent">
      <nav>
        <div className="flex flex-wrap items-center justify-between mx-auto py-4 lg:py-10 px-4  xl:px-[10%] 2xl:px-[11%] 3xl:px-[14%] 4xl:px-[15%] 5xl:px-[16.5%] 6xl:px-[21%] 7xl:px-[21%] lg:px-24">
          {/* Logo */}
          <a href="/" className="flex items-start rtl:space-x-reverse">
            <img src="/images/logo.webp" className="h-14 lg:h-14" alt="Logo" />
          </a>
          {/* Hamburger Icon */}
          <button
            onClick={toggleMenu}
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm rounded-lg md:hidden text-blue"
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          {/* Mobile Menu */}
          <div
            className={`${
              isOpen ? "block" : "hidden"
            } w-full md:block md:w-auto bg-white md:bg-transparent rounded-lg`}
            id="navbar-default"
          >
            <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 rounded-lg md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 items-center">
              {landingPageData.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.link}
                    className={`block py-2 px-3 rounded md:bg-transparent md:p-0 ${
                      isActive(link.link) ? "text-blue" : "text-black"
                    }`}
                    aria-current={isActive(link.link) ? "page" : undefined}
                  >
                    {link.button ? null : link.name}
                  </a>
                </li>
              ))}
              {landingPageData.map((link) =>
                link.button ? (
                  <li key="login">
                    <a
                      href={link.link}
                      className="bg-blue text-white py-3 px-10 rounded-md flex justify-center items-center cursor-pointer"
                    >
                      {link.name}
                    </a>
                  </li>
                ) : null
              )}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
